import React from 'react';
function CommentIcon({ fill = '#000', width = 16, height = 14, opacity = 0.8 }) {
    return (
        <svg width={width} height={height} viewBox="0 0 14 12" fill={fill} opacity={opacity} fillRule="nonzero">
            <path d="M7.492 9.342l2.895 2.553a.445.445 0 0 0 .453.075.384.384 0 0 0 .252-.35V9.342h.86C13.08 9.342 14 8.498 14 7.456v-5.57C14 .848 13.084 0 11.953 0H2.047C.921 0 0 .844 0 1.886v5.57c0 1.038.916 1.886 2.047 1.886h5.445z" />
        </svg>
    );
}

export default CommentIcon;
